import ApiService from "../ApiService";

const userAppService = {
    searchTemporal(identification, page, rowsPerPage) {
        return ApiService.get(`/user-app/searchTemporal?page=${page}&perPage=${rowsPerPage}&identification=${identification}`)
    },
    searchTemporalALL(identification, page, rowsPerPage) {
        return ApiService.get(`/user-app/searchTemporalALL?page=${page}&perPage=${rowsPerPage}&identification=${identification}`)
    },
    approveTemporal(user) {
        return ApiService.post('/user-app/approveTemporal', user)
    },
    denyTemporal(user) {
        return ApiService.post('/user-app/denyTemporal', user)
    }
};

export default userAppService;